import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';
import DiscountApprovalList from './discountApprovalList/discountApprovalList';
import { SectionTitle, Spacer, AlertText } from './css';
import AddDiscountPopup from './addDiscountPopup/addDiscountPopup';
import Note from '../../../note';
import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';


const DiscountApprovalSection = ({
  orderId,
  term,
  discounts,
  onDiscountAdded,
  onDiscountUpdated,
  onDiscountError,
  managedITServicesMonthly,
  appliedDiscountId,
  onApplyDiscount,
  discountError,
  discountWarnings,
  managedItServicesTotal,
  onboardingFee,
  channel
}) => {
  const locale = useLocaleContext();
  const {
    srtDashboardFM: { _12MonthTermFM }
  } = locale === 'en-US' ? EN : FR;
  const [isModalOpen, setModalOpen] = useState(false);
  const [discountToOveride, setDiscountToOverride] = useState(null)
  
  const onOverrideDiscount = (e, id) => {
    setDiscountToOverride(discounts.find(discount => discount.id === id));
  }

  return (
    <>
      <SectionTitle>Discount Request</SectionTitle>
      <Note
        type="text"
        text="Note: If you have an approved discount but then change the Managed IT services or Onboarding value, then the discount will no longer be valid and must be resubmitted."
        isShowNoteBackground
      />
      {
        discountWarnings.map((warning) => (
          <AlertText type='warning'>
            {warning}
          </AlertText>
        ))
      }
      {
          discountError && 
          <AlertText type='error'>
           {discountError}
          </AlertText>
      }
      {
      !discountError && !discountWarnings.length &&
        <>
          <Spacer />
          <Button onClick={() => setModalOpen(true)}>
            Add Discount
          </Button>
        </>
      }

      <Spacer />
      <Spacer />
      <DiscountApprovalList 
        discounts={discounts} 
        appliedDiscountId={appliedDiscountId} 
        onApplyDiscount={(id, action) => onApplyDiscount(id, action)}
        term={term}
        managedItServicesTotal={managedItServicesTotal}
        onboardingFee={onboardingFee}
        onOverrideDiscount={onOverrideDiscount}
      />
      <AddDiscountPopup
        isModalOpen={isModalOpen}
        setModalOpen={setModalOpen}
        orderId={orderId}
        term={term}
        onDiscountAdded={(id) => onDiscountAdded(id)}
        onDiscountError={onDiscountError}
        managedItServices={managedItServicesTotal}
        onboardingFee={onboardingFee}
        channel={channel}
      />
      {!!discountToOveride && <AddDiscountPopup
        isModalOpen={!!discountToOveride}
        setModalOpen={setDiscountToOverride}
        orderId={orderId}
        term={term}
        onDiscountUpdated={(id) => onDiscountUpdated(id)}
        onDiscountError={onDiscountError}
        managedItServices={managedItServicesTotal}
        onboardingFee={onboardingFee}
        discountToOveride={discountToOveride}
        channel={channel}
      />}
    </>
  );
};

DiscountApprovalSection.propTypes = {
  orderId: PropTypes.number.isRequired,
  term: PropTypes.string.isRequired,
  onDiscountAdded: PropTypes.func.isRequired,
  onDiscountError: PropTypes.func.isRequired,
  managedITServicesMonthly: PropTypes.number.isRequired,
  appliedDiscountId: PropTypes.number.isRequired,
  onApplyDiscount: PropTypes.func.isRequired,
  discountError: PropTypes.string.isRequired,
  discountWarnings: PropTypes.arrayOf(PropTypes.string).isRequired,
  managedItServicesTotal: PropTypes.number.isRequired,
  onboardingFee: PropTypes.number.isRequired,
  onDiscountUpdated: PropTypes.func.isRequired,
  channel: PropTypes.string.isRequired
};

export default DiscountApprovalSection;
